import Vue from 'vue';
import App from './App.vue';

// Date and Time library
import '@/plugins/moment';

import store from './store/store';
import router from '@/routes/router';

// Component library
import '@/plugins/vuesax';

// Animate.css
import 'animate.css';

// Way to fake ajax requests
// import './fake-db/index.js'

// Globally Registered Components
import './globals.js';

// Styles: SCSS
import '@/assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Load Script
import '@/plugins/loadScript';

// Filters
import '@/filters/filters';

// Clipboard
import '@/plugins/vue-clipboard';

// Promise based dialog system
import '@/plugins/dialog';

import { APIHelper, ArchistarAnalytics, ArchistarAuthTypes, AuthUser } from '@archistarai/auth-frontend';
import { GetCountrySpecificServerURLMap } from './classes/GetCountrySpecificServerURLMap.js';

let countryCode = 'au';
//let countryCode = AuthUser.getActiveCountry() ?? 'au';
let cityKey = null;

const domainForCallback = window ? window.location.origin : '';
const apiParams = {
  appName: ArchistarAuthTypes.AppNames.admin,
  nodeEnv: process.env.NODE_ENV,
  debugModeValidate: process.env.VUE_APP_DEBUG_MODE_VALIDATE || false,
  loginFlow: undefined,
  oauthConfig: {
    OAUTH_SERVER_URL: process.env.VUE_APP_OAUTH_SERVER_URL,
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    CALLBACK_URL: `${domainForCallback}/passback`
  },
  serverURLMap: GetCountrySpecificServerURLMap(countryCode),
  updateCountryCodeCookie: false,
  countryCode: countryCode,
  cityKey: cityKey
};
if (process.env.VUE_APP_CLIENT_SECRET) {
  apiParams.oauthConfig.CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
}
APIHelper.init(apiParams);

Vue.prototype.$APIHelper = APIHelper;
Vue.prototype.$authUser = AuthUser;

// Gesture control library
import '@/plugins/hammer';

// Form validation
import '@/plugins/vee-validate';

// Feather icons
require('./assets/css/iconfont.css');

Vue.config.productionTip = false;

const enterprise = require('ag-grid-enterprise');
enterprise.LicenseManager.setLicenseKey(
  'CompanyName=Archistar,LicensedApplication=Archistar,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-008944,ExpiryDate=16_July_2021_[v2]_MTYyNjM5MDAwMDAwMA==c1f2799d1acb4bb97ca3536bfe19f5ac'
);

// Analytics
if (process.env.NODE_ENV === 'production') {
  ArchistarAnalytics.initVue2(ArchistarAuthTypes.AppNames.admin, Vue);
}

new Vue({
  data() {
    return {
      appEnv: process.env.NODE_ENV
    };
  },
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
